import { GoogleMapsConstants } from '../app/core/constants/maps-constants';

export const environment = {
    production: false,
    apiUrl: 'https://developcoordinationappservice.azurewebsites.net',
    logoutReturnTo: 'https://nxgen-dev.enterprisewireless.org',
    registrationCompleteLogoutReturnTo:
        'https://nxgen-dev.enterprisewireless.org/registration-complete',
    ewaWebsiteUrl: 'https://dev-ewa-backdrop.pantheonsite.io',
    googleMapsApiKey: GoogleMapsConstants.API_KEY,
    googleMapsMapId: GoogleMapsConstants.MAP_ID,
    auth0: {
        domain: 'develop.security.enterprisewireless.org',
        clientId: 'JuEPPG7n3doYzXvNvhzktjF0EBpkBok1',
        authorizationParams: {
            redirect_uri: 'https://nxgen-dev.enterprisewireless.org',
        },
    },
};
